import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { sendList } from "@/api/work/work";
import { flowCategory, flowRoute } from "@/util/flow";
export default {
  data: function data() {
    return {
      form: {},
      selectionId: '',
      selectionList: [],
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      flowBox: false,
      flowUrl: '',
      workBox: false,
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        selection: true,
        editBtn: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        dialogWidth: 900,
        menuWidth: 150,
        dialogClickModal: false,
        column: [{
          label: "流程分类",
          type: "select",
          row: true,
          dicUrl: "/api/blade-system/dict/dictionary?code=flow",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          slot: true,
          prop: "category",
          search: true,
          hide: true,
          width: 100
        }, {
          label: '流程名称',
          prop: 'processDefinitionName',
          search: true
        }, {
          label: '当前步骤',
          prop: 'taskName'
        }, {
          label: '流程版本',
          prop: 'processDefinitionVersion',
          slot: true,
          width: 80
        }, {
          label: '流程进度',
          prop: 'processIsFinished',
          slot: true,
          width: 80
        }, {
          label: '申请时间',
          prop: 'createTime',
          width: 165
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission", "flowRoutes"])), {}, {
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDetail: function handleDetail(row) {
      this.$router.push({
        path: "/work/process/".concat(flowRoute(this.flowRoutes, row.category), "/detail/").concat(row.processInstanceId, "/").concat(row.businessId)
      });
    },
    handleImage: function handleImage(row) {
      this.flowUrl = "/api/blade-flow/process/diagram-view?processInstanceId=".concat(row.processInstanceId);
      this.flowBox = true;
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var query = _objectSpread(_objectSpread({}, this.query), {}, {
        category: params.category ? flowCategory(params.category) : null
      });

      this.loading = true;
      sendList(page.currentPage, page.pageSize, Object.assign(params, query)).then(function (res) {
        var data = res.data.data;
        _this.page.total = data.total;
        _this.data = data.records;
        _this.loading = false;

        _this.selectionClear();
      });
    }
  }
};